import img1 from '../images/benefits/img1.png';
import img2 from '../images/benefits/img2.png';
import img3 from '../images/benefits/img3.png';
import img4 from '../images/benefits/img4.png';
import img5 from '../images/benefits/img5.png';
import img6 from '../images/benefits/img6.png';

const benefits = [
	{
		img: img1,
		title: 'Maestros especialistas',
		body: 'Los maestros no son generalistas. Nuestros maestros son especialistas en cada una de las áreas y con experiencia en la industria real.',
	},
	{
		img: img2,
		title: 'Premiamos la excelencia',
		body: 'Brindamos becas a los estudiantes que obtengan resultados excelentes.',
	},
	{
		img: img3,
		title: 'Estudia 100% online desde cualquier parte del mundo',
		body: 'No limites tu aprendizaje, hoy puedes estudiar desde cualquier parte del mundo de habla hispana.',
	},
	{
		img: img4,
		title: 'Estudia online en vivo o a tu ritmo, tú elijes',
		body: 'Tenemos todas las opciones para ti: Clases online en vivo, Clases en video con feedback online en vivo, Clases en video para aprender a tu ritmo.',
	},
	{
		img: img5,
		title: 'Entrenamientos Especializados',
		body: 'Te ofrecemos entrenamientos especializados. Somos especialistas en el desarrollo de contenidos digitales con alto impacto en innovación.',
	},
	{
		img: img6,
		title: 'Alcanza un nivel superior en corto tiempo',
		body: 'Con nuestros másteres llegarás a niveles avanzados en menos de un año.',
	},
];

export default benefits;
